import React from 'react';
import PropTypes from 'prop-types';

import { DetailCell, WidthIcon, IconContainer } from './styled';

const t = {
  meters: 'm',
};

const VehicleContainerWidth = ({ container_width, ...props }) => (
  <DetailCell {...props}>
    {!!container_width && (
      <IconContainer>
        {container_width} {t.meters}
        <WidthIcon />
      </IconContainer>
    )}
  </DetailCell>
);

VehicleContainerWidth.propTypes = {
  container_width: PropTypes.string,
};

export default VehicleContainerWidth;
